<template>
  <div :class="['tabbar',noBg?'tabbar_nbg':'']">
    <div
      :class="['tabbar_list',cur==index ? 'cur' :'']"
      v-for="(item,index) of tabList"
      :key="index"
      @click="tabClick(index)"
    >
      <span>{{item}}</span>
      <i></i>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'tabBar',
  props: {
    tabList: Array,
    cur:Number,
    noBg:{
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
    };
  },
  created () {},
  methods: {
    tabClick (val) {
      this.$emit('tabClick', val)
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common.less";
.tabbar {
  .flex();
  justify-content: center;
  width: 100%;
  height: 88px;
  margin: 0 auto;
  background: #fff;
  .tabbar_list {
    .flex(column);
    text-align: center;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding-top: 26px;
    span {
      height: 40px;
      line-height: 40px;
      color: @color9;
    }
    i {
      width: 32px;
      height: 6px;
      background: transparent;
    }
    &.cur {
      span {
        color: @color17;
        font-weight:bold;
      }
      i{
        background: @color17;
      }
    }
  }
}
.tabbar_nbg{
  background:transparent;
  .cur{
    i{
      background:@color17 !important;
    }
  }
}
</style>